import React, { useEffect } from "react";
import { Close, FileDownload } from "../../../assets/svg/AllSvg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Logo } from "../../../assets/image";
import { useDispatch, useSelector } from "react-redux";
import { getBillingTransactionsDetails } from "../../../redux/billingSubscriptions/slice";
import RippleLoader from "../../../commons/RippleLoader";
import moment from "moment";
import SubscriptionSummary from "../../../commons/SubscriptionSummary";

const ViewInformation = ({ onClose, isId }) => {
  const dispatch = useDispatch();

  // selector
  const { getBillingSubscriptionsData, loading } = useSelector((store) => ({
    getBillingSubscriptionsData:
      store?.billingSubscriptionsData?.getBillingTransactionsDetailsStatus?.data
        ?.data,
    loading: store?.billingSubscriptionsData?.loading,
  }));

  useEffect(() => {
    if (isId) {
      dispatch(getBillingTransactionsDetails(isId));
    }
  }, [dispatch, isId]);

  const downloadPdf = () => {
    const input = document.getElementById("pdfContent");

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("receipt.pdf");
    });
  };

  return (
    <div className="model" onClick={onClose}>
      <div
        className="bg-white drop-shadow-lg rounded-lg w-full max-w-4xl max-h-[calc(100vh-100px)] overflow-y-auto min-h-40 py-8 px-6 mx-auto relative"
        id="pdfContent"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <button className="absolute top-5 right-5" onClick={onClose}>
          <Close />
        </button>
        {loading ? (
          <RippleLoader />
        ) : (
          <>
            <div className="space-y-5" id="pdfContent">
              <div className="sm:flex justify-between items-center">
                <div className="sm:w-20 sm:h-20 w-12 h-12">
                  <img
                    src={Logo}
                    alt="logo"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="max-w-60 space-y-1">
                  <p className="sm:text-base text-sm">
                    SGCorpHub Management Pte Ltd{" "}
                  </p>
                  <p className="font-normal sm:text-base text-sm">
                    <span>Address: </span>
                    123 Seng Kang #01-03 S123456
                  </p>
                  <p className="font-normal sm:text-base text-sm">
                    <span>Contact No: </span> 9090 9090
                  </p>
                </div>
              </div>
              <div className="text-sm">
                <p className="font-ebGaramond sm:text-3xl text-xl mb-5">
                  Receipt Summary
                </p>
                <p>ID: {getBillingSubscriptionsData?.order_id}</p>
                <p className="mb-3 capitalize">
                  Customer Name:{" "}
                  {getBillingSubscriptionsData?.user?.full_name?.replace(
                    "_",
                    " "
                  ) || "-"}
                </p>
                <p>
                  Date:{" "}
                  {moment(getBillingSubscriptionsData?.updated_at).format(
                    "DD/MM/YYYY | HH:MM A"
                  )}
                </p>
              </div>
              <table
                className={`w-full text-sm lg:overflow-visible overflow-x-auto min-w-[200px] custom-scroll mb-4`}
              >
                {/* column headers */}
                <thead className="text-sm text-gray-700 bg-secondary_light_shades font-semibold ">
                  <tr>
                    <th
                      scope="col"
                      className="px-5 py-3 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades whitespace-nowrap "
                    >
                      No.
                    </th>
                    <th
                      scope="col"
                      className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
                    >
                      Request
                    </th>
                    <th
                      scope="col"
                      className="px-5 py-2 border-b table_responsive_text font-semibold bg-secondary_light_shades"
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      className="px-5 py-2 border-b table_responsive_text font-semibold bg-secondary_light_shades"
                    >
                      Description
                    </th>
                  </tr>
                </thead>

                {/* table body */}
                <tbody className="relative">
                  {/* Merged Recurring Items and Other Items */}
                  {[
                    ...(getBillingSubscriptionsData?.model?.company_recurrings?.map(
                      (item) => ({
                        ...item,
                        isRecurring: true,
                      })
                    ) || []),
                    ...(getBillingSubscriptionsData?.model?.others?.map(
                      (item) => ({
                        ...item,
                        isRecurring: false,
                      })
                    ) || []),
                  ]
                    .map((item) => {
                      const serviceName = item.isRecurring
                        ? getBillingSubscriptionsData?.model?.company_recurrings?.find(
                            (option) =>
                              option.value === item.recurring_billing_item_id
                          )?.label || item.service_name
                        : getBillingSubscriptionsData?.model?.others?.find(
                            (option) =>
                              option.value === item.other_billing_item_id
                          )?.label || item.service_name;

                      return {
                        ...item,
                        serviceName,
                      };
                    })
                    .filter(
                      (item) =>
                        item.serviceName &&
                        item.price !== undefined &&
                        item.price !== null &&
                        item.price !== ""
                    )
                    .map((item, index) => {
                      return (
                        <tr
                          key={`${
                            item.isRecurring ? "recurring" : "other"
                          }-${index}`}
                          className="border-b text-sm"
                        >
                          <td className="px-5 py-3">
                            {String(index + 1).padStart(2, "0")}
                          </td>
                          <td className="px-5 py-3">{item.serviceName}</td>
                          <td className="text-center px-5 py-3">
                            ${item.price}
                          </td>
                          <td className="px-5 py-3">{item.description}</td>
                        </tr>
                      );
                    })}
                  <tr>
                    <td className="px-5 py-3">
                      0
                      {getBillingSubscriptionsData?.model?.service_requests
                        ?.length
                        ? getBillingSubscriptionsData?.model?.service_requests
                            ?.length + 1
                        : getBillingSubscriptionsData?.model?.company_recurrings
                            ?.length +
                          getBillingSubscriptionsData?.model?.others?.length +
                          1}
                    </td>
                    <td className="px-5 py-3">Incorporate Fees</td>
                    <td className="px-5 py-3"></td>
                    <td className="text-center px-5 py-3">
                      $
                      {
                        getBillingSubscriptionsData?.model?.detail
                          ?.incorporation_fees
                      }
                    </td>
                  </tr>
                  <tr>
                    <td className="px-5 py-3">
                      0
                      {getBillingSubscriptionsData?.model?.service_requests
                        ?.length
                        ? getBillingSubscriptionsData?.model?.service_requests
                            ?.length + 2
                        : getBillingSubscriptionsData?.model?.company_recurrings
                            ?.length +
                          getBillingSubscriptionsData?.model?.others?.length +
                          2}
                    </td>
                    <td className="px-5 py-3">Govt Fees</td>
                    <td className="px-5 py-3"></td>
                    <td className="text-center px-5 py-3">
                      ${getBillingSubscriptionsData?.model?.detail?.govt_fees}
                    </td>
                  </tr>
                </tbody>
              </table>
              <SubscriptionSummary
                companySubscriptionDetails={getBillingSubscriptionsData}
              />
              {/* <div className="text-right !mb-10  sm:text-base text-sm">
                <p>
                  Subtotal: $
                  {getBillingSubscriptionsData?.detail?.sub_total ||
                    getBillingSubscriptionsData?.amount}
                </p>
                <p>
                  Total: $
                  {getBillingSubscriptionsData?.detail?.total ||
                    getBillingSubscriptionsData?.amount}
                </p>
              </div> */}
              <p className="!mb-10 sm:text-base text-sm">TnC Here</p>
            </div>
            <div className="flex justify-end">
              <button
                className="btn-theme flex items-center"
                onClick={downloadPdf}
              >
                <FileDownload
                  width="14"
                  height="17"
                  className="mr-2"
                  fillColor="fill-white"
                />
                PDF - summary
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewInformation;
